export default "__VITE_ASSET__d568daa0__"